import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';
import type { CSSProperties, FunctionComponent } from 'react';

const rotate = keyframes`
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
`;

const StyledSpinner = styled.div`
    width: 12px;
    height: 12px;
    border: 2px solid transparent;
    border-top: 2px solid currentColor;
    border-radius: 50%;
    margin-right: ${({ theme }) => theme.spacing.xs};
    animation: ${rotate} 1s linear infinite;
`;

export const Spinner: FunctionComponent<{ readonly style?: CSSProperties }> = ({ style }) => (
    <StyledSpinner data-testid="spinner" style={style} />
);
